import './style.scss';

import configStore from './configStore';
import WebViewerSDK from "./webViewerSDK";

const viewerSDK = new WebViewerSDK(configStore);
export default viewerSDK;